module.exports = __webpack_public_path__ + "img/icbccredit.7e92ce8a.png";